import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.34771 2.03976C4.87805 1.40335 5.8239 1.31736 6.46031 1.84771L12.4603 6.84771C12.8023 7.1327 13 7.55487 13 8.00004C13 8.44521 12.8023 8.86738 12.4603 9.15237L6.46031 14.1524C5.8239 14.6827 4.87805 14.5967 4.34771 13.9603C3.81736 13.3239 3.90335 12.3781 4.53976 11.8477L9.15696 8.00004L4.53976 4.15237C3.90335 3.62202 3.81736 2.67618 4.34771 2.03976Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }